export var checkLabel = function checkLabel(_ref) {
  var _option$;
  var option = _ref.option,
    icon = _ref.icon,
    title = _ref.title,
    emptyValueText = _ref.emptyValueText;
  var finalCondition = '';
  var isArray = Array.isArray(option);
  if (isArray && !((_option$ = option[0]) !== null && _option$ !== void 0 && _option$.id) && emptyValueText) {
    finalCondition = emptyValueText;
  }
  if (!isArray) {
    finalCondition = (option === null || option === void 0 ? void 0 : option.label) || emptyValueText || '';
  }
  if (icon) {
    return '';
  }
  return title || finalCondition;
};